module.exports = __webpack_public_path__ + "site/img/63.af1f4278.jpg";